import { type PollsDataSource } from '../../data/polls.datasource'
import { type PollEntity } from '../../data/entities/poll.entity'
import { type PollSummary } from '../models/poll.model'

const toSummary = (e: PollEntity): PollSummary => ({
  id: e.id,
  postId: e.postId,
  question: e.question,
  state: e.state,
  totalVotes: e.totalVotes,
  closesAt: new Date(e.closesAt),
  options: e.options.map((o) => ({
    id: o.id,
    text: o.text,
    order: o.order,
    voteCount: o.voteCount
  }))
})

export class GetPollsInteractor {
  constructor(private readonly dataSource: PollsDataSource) {}

  async execute(search?: string): Promise<PollSummary[]> {
    const entities = await this.dataSource.list()
    let results = entities.map(toSummary)
    if (search?.trim()) {
      const term = search.trim().toLowerCase()
      results = results.filter((r) => r.question.toLowerCase().includes(term))
    }
    return results
  }
}
